import { render, staticRenderFns } from "./Vacinas.vue?vue&type=template&id=205d6295&scoped=true"
import script from "./Vacinas.vue?vue&type=script&lang=js"
export * from "./Vacinas.vue?vue&type=script&lang=js"
import style0 from "./Vacinas.vue?vue&type=style&index=0&id=205d6295&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d6295",
  null
  
)

export default component.exports